export default "__VITE_ASSET__CCfPeHwZ__"